import React from 'react'
import './index.css'

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }
  render() {
    let className = 'style-button';
    if (this.props.active) {
      className += ' active-button';
    }
    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

export default StyleButton



/** WEBPACK FOOTER **
 ** ./src/Editors/StyleButton/StyleButton.js
 **/